<template>
	<div class="box">
		<div class="block-title">充电走势图</div>
		<div id="" class="">
			<div id="fb01" ref="echartTrendDiv" style="100%; height: 313px; padding: 20px"></div>
		</div>
		<div class="leidanav leidanav2"></div>
	</div>
</template>
<script>
	import * as echarts from 'echarts';

	export default {
		data() {
			return {
				trendChart: null
			}
		},
		mounted() {
			this.trendChart = echarts.init(this.$refs.echartTrendDiv);
			window.addEventListener('resize', () => this.trendChart.resize());
		},
		methods: {
			setData(data) {
				chartOption.xAxis.data = data.TimePoints;
				chartOption.series[0].data = data.ChargeKwhs;
				chartOption.series[1].data = data.ChargeNums;
				this.trendChart.setOption(chartOption);
			}
		}
	}

	function inityAxis(name) {
		return {
			type: 'value',
			name,
			spiltNumber: 10,
			splitLine: {
				show: false,
				lineStyle: {
					// 网格风格
					color: 'rgba(205,215,255,0.1)',
					width: 1, // 这里是为了突出显示加上的，可以去掉
					// type: 'dashed',
				},
			},
			axisLine: {
				show: true,
				lineStyle: {
					color: 'rgba(255,255,255,0.2)',
					width: 1,
				},
			},
			axisLabel: {
				show: true,
				color: 'rgba(255,255,255,0.6)',
			},
			nameTextStyle: {
				color: 'rgba(255,255,255,0.5)',
			},
		};
	}

	function initTrendSeries(name, yAxisIndex, area = true) {
		return {
			name /* '充电电量' */ ,
			type: 'line',
			smooth: true,
			connectNulls: true,
			areaStyle: area ? {} : null,
			// tooltip: {
			//    trigger: 'axis',
			//    //formatter: '{a0}: {c0}<br />{a1}: {c1}',
			//    textStyle: { align: 'left', },
			// },
			yAxisIndex,
			data: [],
			visualMap: false,
			label: {
				color: 'white',
			},
		};
	}

	let chartOption = {
		color: ['#BDF090', '#4DCEF8', '#BBBBBB', '#FF9F7F'],
		tooltip: {
			show: true,
			trigger: 'axis',
		},
		legend: {
			data: ['充电电量', '充电次数'],
			textStyle: {
				color: '#929ca8',
			},
		},
		grid: {
			// 显示网格
			// z: 50,
			left: 55,
			right: 40,
			top: 50,
			bottom: 35,
			show: false,
			borderColor: 'rgba(255,255,255,0.6)',
		},
		xAxis: {
			type: 'category',
			name: '时间',
			splitLine: {
				show: false, // 显示网格
				lineStyle: {
					// 网格风格
					color: 'rgba(255,255,255,0.15)',
					// width: 1,//这里是为了突出显示加上的，可以去掉
					// type: 'dashed',
				},
			},
			boundaryGap: false,
			data: [],
			nameTextStyle: {
				color: 'rgba(255,255,255,0.5)',
				verticalAlign: 'top',
				padding: [8, 0, 0, 0],
			},
			axisLine: {
				show: true,
				lineStyle: {
					color: 'rgba(255,255,255,0.1)',
					width: 1, // 这里是为了突出显示加上的，可以去掉
				},
			},
			axisLabel: {
				show: true,
				color: 'rgba(255,255,255,0.5)',
			},
			asixTick: {
				show: false,
			},
		},
		yAxis: [inityAxis('充电电量(度)'), inityAxis('充电次数(次)')],
		series: [initTrendSeries('充电电量', 0), initTrendSeries('充电次数', 1, false)],
	};
</script>
<style type="less" scoped>
	@import '../style.css';
</style>